import { wholesale_forecast_by_account_path } from "@/lib/routes";
import { useMarket } from "@/lib/useMarket";

export interface AccountRow {
  id: string;
  name: string;
  picName: string | null;
  units: number;
}

interface Props {
  monthLabel: string;
  total: number;
  contributing: number;
  accounts: AccountRow[];
  productExternalId: string;
}

function formatQty(n: number): string {
  return n.toLocaleString("en-US");
}

export default function ForecastAccountsPopover({
  monthLabel,
  total,
  contributing,
  accounts,
  productExternalId,
}: Props) {
  const market = useMarket();
  return (
    <div>
      <div className="flex items-baseline gap-1.5 pb-2 mb-1 border-b border-border">
        <span className="font-semibold">{monthLabel}</span>
        <span className="text-xs text-muted-foreground">
          {formatQty(total)} units · {contributing} of {accounts.length} accounts
        </span>
      </div>
      <div className="max-h-64 overflow-y-auto pr-1 [scrollbar-width:thin] [scrollbar-color:var(--border)_transparent] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-border">
        {accounts.map((a) => (
          <div key={a.id} className="flex items-start gap-2 py-1">
            <div className="min-w-0 flex-1">
              <div className="font-medium break-words">{a.name}</div>
              {a.picName && (
                <div className="text-xs text-muted-foreground break-words">{a.picName}</div>
              )}
            </div>
            <span className="shrink-0 pl-2">
              {a.units > 0 ? formatQty(a.units) : <span className="text-muted-foreground">—</span>}
            </span>
          </div>
        ))}
      </div>
      <a
        href={wholesale_forecast_by_account_path(market.slug, { product_id: productExternalId })}
        target="_blank"
        rel="noopener"
        className="block pt-2 mt-1 border-t border-border text-xs text-link hover:underline"
      >
        Open in Wholesale Forecast →
      </a>
    </div>
  );
}
